
var stringUtil = require('../../../../utils/string/stringUtil');
var constants = require('../../../../utils/domain/constants.js');
var saleInitializer = require('../../../../utils/domain/sales/saleInitializer');
var saleContextUtil = require('../../utils/saleContextUtil');

module.exports.buildRequiredModifiers = function (menuItem, isNewOrderFlow)
{
    var requiredModifiers = [];
    
    if (menuItem.modifiers == null || menuItem.modifiers.length <= 0)
        return requiredModifiers;

    for (var index = 0; index < menuItem.modifiers.length; index++)
    {
        var modifier = menuItem.modifiers[index];
        
        if (this.isEmptyModifier(modifier))
            continue;

        if (isNewOrderFlow && modifier.hiddenInOrderFlow)
            continue;

        if (isNewOrderFlow && this.isModifierSystemAutoSelected(modifier))
            continue;

        requiredModifiers.push(modifier);
    }
    return requiredModifiers;
}


module.exports.buildAutoSelectedModifierItems = function (menuItem)
{
    var selectedModifierItems = [];
    
    if (menuItem.modifiers == null || menuItem.modifiers.length <= 0)
        return selectedModifierItems;

    for (var index = 0; index < menuItem.modifiers.length; index++)
    {
        var modifier = menuItem.modifiers[index];
        
        if (this.isEmptyModifier(modifier))
            continue;

        this.buildAutoSelectedModifierItemsForModifier(modifier, selectedModifierItems);
    }

    return selectedModifierItems;
}

module.exports.buildAutoSelectedModifierItemsForModifier = function (modifier, selectedModifierItems)
{
    for (var index = 0; index < modifier.items.length; index++)
    {
        var modifierItem = modifier.items[index];

        var autoSelectedQuantity = 0;

        if (modifier.min == modifier.max && modifier.items.length == 1)
            autoSelectedQuantity = modifier.min;
        else if (!stringUtil.isStringNullOrEmpty(modifierItem.autoSelectedQuantity) &&  modifierItem.autoSelectedQuantity > 0)
            autoSelectedQuantity = modifierItem.autoSelectedQuantity;

        for (var qtyIndex = 0; qtyIndex < autoSelectedQuantity; qtyIndex++)
        {
            let selectedModifierItem = {};
            selectedModifierItem.modifier = modifier;
            selectedModifierItem.menuItem = modifierItem;
            selectedModifierItem.selectedModifierItems = [];
            selectedModifierItems.push(selectedModifierItem);

            if (modifierItem.modifiers != null && modifierItem.modifiers.length > 0)
            {
                for (var subModifierIndex = 0; subModifierIndex < modifierItem.modifiers.length; subModifierIndex++)
                    this.buildAutoSelectedModifierItemsForModifier(modifierItem.modifiers[subModifierIndex], selectedModifierItem.selectedModifierItems);
            }
        }
    }
}

module.exports.isEmptyModifier = function (modifier)
{
    if (modifier.items == null || modifier.items.length <= 0)
        return true;

    return false;
}

module.exports.isModifierSystemAutoSelected = function(modifier)
{
    if (modifier.min != modifier.max || modifier.items.length != 1)
        return false;

    return true;
}

module.exports.buildNewMenuContext = function(modifier, menuItem)
{
    var menuContext = {};
    menuContext.modifier = modifier;
    menuContext.menuItem = menuItem;
    
    return menuContext;
}

module.exports.buildSaleItemFromMenuContext = function(sale, menuContext, quantity, selectedModifierItems)
{

    let unitPrice = 0;
    let vat = 0;

    unitPrice = menuContext.menuItem.price;
    vat = this.calculateUnitPriceTax(sale, menuContext.menuItem);

    var saleItem = saleInitializer.createSaleItem(menuContext.menuItem.category, quantity, menuContext.menuItem.caption, unitPrice, vat);
    
    saleContextUtil.setSaleItemMenuContext(saleItem, menuContext);
    saleItem.productId = menuContext.menuItem.productId;
    saleItem.unitUpsellingPoints = menuContext.menuItem.upsellingPoints;
    saleItem.paramsJson = buildSaleItemParams(menuContext.menuItem.paramsJson);
    saleItem.backgroundColor = menuContext.menuItem.backgroundColor;
    saleItem.foregroundColor = menuContext.menuItem.foregroundColor;
    saleItem.isNewItem = true;
    
    for (var index = 0; index < selectedModifierItems.length; index++)
    {
        var selectedModifierItem = selectedModifierItems[index];

        var subMenuContext = this.buildNewMenuContext(selectedModifierItem.modifier, selectedModifierItem.menuItem);
        var subSaleItem = this.buildSaleItemFromMenuContext(sale, subMenuContext, quantity, selectedModifierItem.selectedModifierItems);
        saleItem.saleItems.push(subSaleItem);
    }

    return saleItem;
}

module.exports.calculateUnitPriceTax = function(sale, saleMenuItem)
{
    if (sale.saleType != constants.SaleTypeSale)
        return 0.0;

    return saleInitializer.calculateUnitTax(saleMenuItem.taxablePrice, saleMenuItem.tax);
}


module.exports.buildModifiersViewModels = function(saleItem)
{
    var modifiersViewModels = []
    let menuContext = saleContextUtil.getSaleItemMenuContext(saleItem);
    var modifiers = this.buildRequiredModifiers(menuContext.menuItem, false);
    

    let lastWorkflowModifier = null;
    for (var index = 0; index < modifiers.length; index++)
    {
        var modifier = modifiers[index];

        var modifierViewModel = {};
        modifierViewModel.underlyingModifier = modifier;
        modifierViewModel.items = [];
        modifierViewModel.currentItemIndex = 0;
        modifierViewModel.previousSibling = lastWorkflowModifier;
        if (lastWorkflowModifier != null)
        {
            lastWorkflowModifier.nextSibling = modifierViewModel;
        }
        lastWorkflowModifier = modifierViewModel;

        this.buildModifierViewModel(saleItem, modifierViewModel);
        modifiersViewModels.push(modifierViewModel);
    }

    return modifiersViewModels;
}

module.exports.buildModifierViewModel = function(saleItem, modifierViewModel)
{
    for (var index = 0; index < modifierViewModel.underlyingModifier.items.length; index++)
    {
        var modifierItem = modifierViewModel.underlyingModifier.items[index];
        
        var modifierItemViewModel = {};
        modifierItemViewModel.underlyingModifierItem = modifierItem;
        modifierItemViewModel.quantity = this.findModifierItemQuantity(saleItem, modifierViewModel.underlyingModifier, modifierItem);
        modifierItemViewModel.modifiersViewModels = [];

        modifierViewModel.items.push(modifierItemViewModel);

        var modifiers = this.buildRequiredModifiers(modifierItem, false)
        
        let lastModifierViewModel = null;
        for (var subIndex = 0; subIndex < modifiers.length; subIndex++)
        {
            var subModifier = modifiers[subIndex];
            
            var subModifierViewModel = {};
            subModifierViewModel.underlyingModifier = subModifier;
            subModifierViewModel.items = [];
            subModifierViewModel.currentItemIndex = 0;
            subModifierViewModel.previousSibling = lastModifierViewModel;
            if (lastModifierViewModel != null)
            {
                lastModifierViewModel.nextSibling = subModifierViewModel;
            }
            lastModifierViewModel = subModifierViewModel;

            modifierItemViewModel.modifiersViewModels.push(subModifierViewModel);

            this.buildModifierViewModel(saleItem, subModifierViewModel);
        }
    }
}

module.exports.findModifierItemQuantity = function(saleItem, modifier, modifierItem)
{
    var quantity = 0;

    saleItem.saleItems.forEach (subSaleItem =>
    {
        let menuContext = saleContextUtil.getSaleItemMenuContext(subSaleItem);
        
        if (stringUtil.areStringSame(menuContext.modifier.id, modifier.id) &&
            stringUtil.areStringSame(menuContext.modifier.membershipId, modifier.membershipId) &&
            stringUtil.areStringSame(menuContext.menuItem.id, modifierItem.id))
        {
            quantity = quantity = quantity + 1;
        }
        else
        {
            quantity = quantity + this.findModifierItemQuantity(subSaleItem, modifier, modifierItem);
        }
    });

    return quantity;
}

module.exports.updateSaleItemWithModifiersViewModels = function(sale, saleItem, modifiersViewModels)
{
    saleItem.saleItems = [];

    modifiersViewModels.forEach (modifierViewModel =>
    {
        this.updateSaleItemWithModifierViewModel(sale, saleItem, modifierViewModel);
    })
}

module.exports.updateSaleItemWithModifierViewModel = function(sale, saleItem, modifierViewModel)
{
    modifierViewModel.items.forEach (modifierItemViewModel =>
    {
        for (var index = 0; index < modifierItemViewModel.quantity; index++)
        {
            let subMenuContext = this.buildNewMenuContext(modifierViewModel.underlyingModifier, modifierItemViewModel.underlyingModifierItem);
            var subSaleItem = this.buildSaleItemFromMenuContext(sale, subMenuContext, saleItem.quantity, []);
            saleItem.saleItems.push(subSaleItem);

            modifierItemViewModel.modifiersViewModels.forEach (subModifierViewModel =>
            {
                this.updateSaleItemWithModifierViewModel(sale, subSaleItem, subModifierViewModel);    
            })
        }
    })
}

module.exports.findParentSaleItem = function (sale, childSaleItem)
{
    
    for (var index = 0; index < sale.saleItems.length; index++)
    {
        var saleItem = sale.saleItems[index];
        var existingIndex = saleItem.saleItems.findIndex(i => i.id == childSaleItem.id);
        if (existingIndex != -1)
            return saleItem;

        for (var iSubIndex = 0; iSubIndex < saleItem.saleItems.length; iSubIndex++)
        {
            var parentItem = this.findParentSaleItemInGivenItem(saleItem.saleItems[iSubIndex], childSaleItem);
            if (parentItem != null)
                return parentItem;
        }
    }

    return null;
}

module.exports.findParentSaleItemInGivenItem = function (parentItem, childSaleItem)
{
    var existingIndex = parentItem.saleItems.findIndex(i => i.id == childSaleItem.id);
    if (existingIndex != -1)
        return parentItem;

    for (var index = 0; index < parentItem.saleItems.length; index++)
    {
        var foundParentItem = this.findParentSaleItemInGivenItem(parentItem.saleItems[index], childSaleItem);
        if (foundParentItem != null)
            return foundParentItem;
    }
}


module.exports.isModifierFullySatisfied = function(modifierViewModel, isRecursive)
{
    var quantity = 0;
    modifierViewModel.items.forEach (modifierItemViewModel =>
    {
        quantity = quantity + modifierItemViewModel.quantity;    
    });

    if (quantity < modifierViewModel.underlyingModifier.min)
        return false;

    if (!isRecursive)
        return true;

    var isSatisfied = true;
    modifierViewModel.items.forEach (modifierItemViewModel =>
    {
        if (modifierItemViewModel.quantity <= 0)
            return;
            
        modifierItemViewModel.modifiersViewModels.forEach (subModifierViewModel =>
        {
            if (!this.isModifierFullySatisfied(subModifierViewModel, isRecursive))
                isSatisfied = false;
        })    
    });

    return isSatisfied;
    
}

function buildSaleItemParams (menuParamsJson)
{
    if(stringUtil.isStringNullOrEmpty(menuParamsJson))
        return null;
    
    const menuItemParams = JSON.parse(menuParamsJson); 
    if(menuItemParams == null)
        return null;

    const saleItemParams = {};
    //Kds, Discount and Report configuration are retained as it it
    saleItemParams.kdsConfiguration = menuItemParams.kdsConfiguration; 
    saleItemParams.discountConfiguration = menuItemParams.discountConfiguration; 
    saleItemParams.reportConfiguration = menuItemParams.reportConfiguration; 

    return JSON.stringify(saleItemParams);
}